import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { setLocalLoading } from "@/store/ui/ui";
import { updateEntity } from "@/services/API/shared";
import { setPatientsData } from "@/store/patients/patients";
import { setGlobalDate } from "@/store/schedule/scheduleSlice";
import { RootState } from "@/store/store";
import { compareDates } from "@/utils/compareDates";
import { updateService } from "@/store/service/service";
import { updateAppointmentComplete } from "@/store/schedule/scheduleSlice";

import { IHandleUpdateParams } from "@/shared/interfaces/patientPage";

export default function useUpdateEntity() {
    const dispatch = useDispatch();
    const globalDate = useSelector(
        (state: RootState) => state.schedule.globalDate,
    );
    const dateCompare = compareDates(new Date(globalDate));

    async function handleUpdate({
        entity,
        id,
        data,
        onSuccess,
    }: IHandleUpdateParams) {
        dispatch(setLocalLoading(true));
        const response = await updateEntity(id, entity, data);

        if (response?.status === "success") {
            toast.success("Дані успішно оновлено");
            if (entity === "services") {
                dispatch(updateService(data));
            }
            if (entity === "patients") {
                dispatch(updateService(data));
                dispatch(setPatientsData(data));
            }
            if (onSuccess) {
                onSuccess();
            }
            if (entity === "appointments") {
                dispatch(updateAppointmentComplete(response.data));
            }
        } else {
            toast.error(response?.message || "Помилка під час видалення");
        }

        dispatch(setLocalLoading(false));

        if (!dateCompare) {
            dispatch(setGlobalDate(new Date().toISOString()));
        }
    }

    return { handleUpdate };
}
